import { render, staticRenderFns } from "./LoginPrimaryBtn.vue?vue&type=template&id=0c528676&scoped=true&functional=true"
var script = {}
import style0 from "./LoginPrimaryBtn.vue?vue&type=style&index=0&id=0c528676&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "0c528676",
  null
  
)

export default component.exports